module.exports = __webpack_public_path__ + "img/Yaoqi_Zhou.e7987d0d.png";